import { useEffect, useState } from 'react';
import { Engine, RuleProperties } from 'json-rules-engine';

export interface Facts {
  [key: string]: unknown;
}

interface UseRulesEngineParams {
  facts: Facts;
  rules: RuleProperties[];
}

export const useRulesEngine = ({ facts, rules }: UseRulesEngineParams) => {
  const [result, setResult] = useState<null | string>(null);

  useEffect(() => {
    const engine = new Engine();

    rules.forEach((rule) => {
      engine.addRule(rule);
    });

    const runEngine = async (factsEffect: Facts) => {
      try {
        const engineResult = await engine.run(factsEffect);
        if (engineResult.events.length > 0) {
          setResult(engineResult.events[0].type);
        } else {
          setResult(null);
        }
      } catch (error) {
        setResult('GenericError');
      }
    };

    runEngine(facts);
  }, [facts, rules]);

  return result;
};
